var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobconfigBannerHemming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 70,
    viewBox: "0 0 128 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    width: 70,
    height: 128,
    rx: 4,
    transform: "rotate(90 128 0)",
    fill: "#BCBDC0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 35,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.798 44.1094H73.1541V32.9772C73.1541 30.2345 73.1541 24.2651 64.8856 24.2651C61.8202 24.2651 58.7952 25.1927 56.6575 27.3708L59.1985 29.9118C60.4892 28.7018 62.3445 27.8951 64.3612 27.8951C66.9426 27.8951 68.798 29.1455 68.798 31.5252V32.0495H67.588C62.7479 32.0495 55.4071 32.4932 55.4071 38.7853C55.4071 42.617 58.8758 44.5934 62.4655 44.5934C65.0469 44.5934 67.3056 43.6254 68.677 41.4473H68.798V44.1094ZM68.5156 36.5266C68.5156 39.229 66.9426 40.9633 63.6352 40.9633C62.0622 40.9633 60.2472 40.197 60.2472 38.4223C60.2472 35.6392 64.8453 35.4376 67.5073 35.4376H68.5156V36.5266Z",
    fill: "#52B3A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobconfigBannerHemming);
export default __webpack_public_path__ + "static/media/jobconfig-banner-hemming.b31ccbf976ede75deec801c66fff4c46.svg";
export { ForwardRef as ReactComponent };